import { VetsuRedirectState } from './VetsuRedirectTypes';
import { VeteransUnitedRedirectConfig } from '../../../types';

export const VetsuRedirectActionTypes = {
  LOAD_VETSU_REDIRECT: 'loadVetsuRedirect',
  LOADED_VETSU_REDIRECT: 'loadedVetsuRedirect',
  LOAD_VETSU_REDIRECT_ERROR: 'loadVetsuRedirectError',

  LOAD_VETSU_REDIRECT_CONFIG: 'loadVetsuRedirectConfig',
  LOADED_VETSU_REDIRECT_CONFIG: 'loadedVetsuRedirectConfig',
  LOAD_VETSU_REDIRECT_CONFIG_ERROR: 'loadVetsuRedirectConfigError',

  SELECT_VETSU_REDIRECT_CONFIG: 'selectVetsuRedirectConfig',

  LOAD_FORM_VALUES: 'loadFormValues',
};

export const DEFAULT_STATE: VetsuRedirectState = {
  vetsURedirectMap: [],
  vetsURedirectConfigMap: [],
  reloadVetsURedirectMap: false,
  reloadVetsURedirectConfigMap: false,
  selectedOption: [],
  formValues: {
    InValue: '',
    ReturnValue: '',
    Ordinal: 0,
    Active: false,
  },
};
